import CustomIcon from "../../../components/CustomIcon";
import React, {useCallback, useEffect, useState} from "react";
import {debounce} from "lodash";
import {resetAll} from "../../../redux/slices/dynamicElementsSlice";
import {resetAll as resetAllDynamic} from "../../../redux/slices/dynamicMultipleElementsSlice";
import { resetSelectedItems, setPagesAddingOrEditing, setPageTabData } from '../../../redux/slices/dynamicUiSlice'
import {useDispatch} from "react-redux";
import PreviewSelected from "./PreviewSelected";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import CustomButton, {DangerButton, OutlinedButton, SecondaryButton} from "../../../components/CustomButton";

const SelectedMoveActions = ({
                               displayMenu, setDisplayMenu, loading, mobileView = true, toggleUiView,pageTabButton = false,
                               previewButton = true, refreshButton = true, editButton = false, deleteButton = false,
                               className, children
                             }) => {
  const dispatch = useDispatch();
  const [previewMode, setPreviewMode] = useState(false);
  // noinspection JSCheckFunctionSignatures
  const debouncedRefreshUi = useCallback(
    debounce(() => {
      dispatch(resetAll());
      dispatch(resetAllDynamic());
      dispatch(resetSelectedItems());
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (previewMode) {
      document.body.style.position = 'fixed';
    } else {
      document.body.style.position = 'static';
    }
  }, [previewMode]);

  return (
    <div className={`px-4 flex items-center space-x-2${className ? ` ${className}` : ''}`}>
      {/*{!!toggleUiView && <SelectedActionButton*/}
      {/*  onClick={toggleUiView} loading={loading} tooltip="toggle view"*/}
      {/*  icon={mobileView ? 'desktop_mac' : 'phone_iphone'}/>}*/}
      {!!toggleUiView &&
        <div
          className={`flex ${loading && 'animate-pulse border-rand-300 cursor-not-allowed'} border-2 border-secondary-500 py-1 px-1 rounded-lg space-x-2`}>
          <button disabled={loading}
                  className={`${mobileView ? `${loading ? 'animate-pulse bg-rand-400 cursor-not-allowed' : 'bg-sky-100 cursor-default'}` : "focus:ring-4 focus:secondary-500 focus:ring-offset-1 focus:ring-offset-white"} py-1 px-1.5 rounded flex items-center focus:outline-none`}
                  title="Switch to Mobile View">
            <CustomIcon icon="phone_iphone" size="base"
                        className={mobileView ? 'text-secondary-500' : 'text-rand-200 cursor-pointer'}
                        onClick={mobileView || loading ? null : toggleUiView}/>
          </button>
          <button disabled={loading}
                  className={`${mobileView ? "focus:ring-4 focus:secondary-500 focus:ring-offset-1 focus:ring-offset-white" : `${loading ? 'animate-pulse bg-rand-400 cursor-not-allowed' : 'bg-sky-100 cursor-default'}`} py-1 px-1.5 rounded flex items-center focus:outline-none`}
                  title="Switch to Web View">
            <CustomIcon icon="desktop_mac" size="base"
                        className={mobileView ? 'text-rand-200 cursor-pointer' : 'text-secondary-500'}
                        onClick={mobileView && !loading ? toggleUiView : null}/>
          </button>
        </div>
      }
      {refreshButton &&
        <SelectedActionButton onClick={debouncedRefreshUi} loading={loading} tooltip="Refresh" icon="refresh"/>}
      {/*{previewButton &&*/}
      {/*  <SelectedActionButton onClick={() => setPreviewMode(true)} loading={loading} tooltip="Preview Play"*/}
      {/*                        icon="play_circle"/>}*/}
      <SelectedActionButton onClick={() => setDisplayMenu(!displayMenu)} loading={loading} tooltip="Show/Hide controls"
                            icon={displayMenu ? 'unfold_more' : 'unfold_less'}/>
      {editButton &&
        <>
          {
            loading ? <SecondaryButton isIconButton={true} className="pointer-events-none">
            <CustomIcon icon="edit" className="text-gray-300"/>
          </SecondaryButton> :
            <OutlinedButton isIconButton={true}
            onClick={() => dispatch(setPagesAddingOrEditing({editing: true}))} title="Edit Page">
              <CustomIcon icon="edit"/>
            </OutlinedButton>
          }
        </>
      }

      {pageTabButton &&
        <>
          {
            loading ? <SecondaryButton isIconButton={true} className="pointer-events-none absolute -right-4" disabled={true}>
                +Add Infinite Scroll
              </SecondaryButton> :
              <CustomButton isIconButton={true} className="absolute -right-4"
                            onClick={() => dispatch(setPageTabData({active: true}))} title="Add Infinite scroll content">
                {/* <CustomIcon icon="tab"/> */}
                +Add Infinite Scroll
              </CustomButton>
          }
        </>
      }

      {deleteButton &&
        <>
          {loading ? <SecondaryButton isIconButton={true} className="pointer-events-none">
          <CustomIcon icon="delete" className="text-gray-300"/>
          </SecondaryButton> :
          <DangerButton isIconButton={true} onClick={() => dispatch(setPagesAddingOrEditing({deleting: true}))} title="Delete Page"><CustomIcon icon="delete"/></DangerButton>}
        </>
      }
      {children}

      {previewMode &&
        <DndProvider backend={HTML5Backend}><PreviewSelected onClose={() => setPreviewMode(false)}/></DndProvider>}
    </div>
  );
};

export default SelectedMoveActions;

export const SelectedActionButton = ({tooltip, loading, onClick, icon, children, ...props}) => {
  return (
    <OutlinedButton isIconButton={true} title={tooltip} onClick={loading ? undefined : onClick}
                    className={loading && 'animate-pulse border-rand-300 cursor-not-allowed'} {...props}>
      {!!icon && <CustomIcon className={loading && 'text-rand-300'} icon={icon}/>}
      {children}
    </OutlinedButton>
    // <div title={tooltip} onClick={loading ? undefined : onClick}
    //      className={`rounded-md leading-none ${loading ? 'animate-pulse bg-rand-200 cursor-not-allowed' :
    //        'cursor-pointer hover:shadow-lg hover:bg-blue-50 bg-secondary-800'}`} {...props}>
    //   {!!icon && <CustomIcon icon={icon}
    //                          className="py-2 px-2 text-white hover:text-primary-500"/>}
    //   {children}
    // </div>
  );
};

export const SelectedActionButtonRef = React.forwardRef(({
                                                           tooltip,
                                                           loading,
                                                           onClick,
                                                           icon,
                                                           children,
                                                           ...props
                                                         }, ref) => (
  <div title={tooltip} onClick={loading ? undefined : onClick}
       className={`rounded-md leading-none ${loading ? 'animate-pulse bg-rand-200 cursor-not-allowed' :
         'cursor-pointer bg-secondary-500 hover:bg-secondary-800 hover:shadow-md active:bg-secondary-800 active:shadow-md cursor-pointer border-secondary-500 focus:outline-none focus:ring-4 focus:secondary-500 focus:ring-offset-2 focus:ring-offset-white transition-all'}`} {...props}
       ref={ref}>
    {!!icon && <CustomIcon icon={icon}
                           className="py-2.5 px-2.5 text-white"/>}
    {children}
  </div>
));